
import Vue from 'vue';
import Component from 'vue-class-component';
import VerifyOtp from '@/app/components/login/VerifyOtp.vue';
import SetPassword from '@/app/components/login/SetPassword.vue';
import SignUp from '@/app/components/sign-up/SignUp.vue';
import WorkspaceSetup from '@/app/components/sign-up/WorkspaceSetup.vue';
import UserProfileSetup from '@/app/components/sign-up/UserProfileSetup.vue';
import InviteTeamMembers from '@/app/components/sign-up/InviteTeamMembers.vue';

@Component({
  name: 'sign_up',
  components: {
    'sign-up': SignUp,
    'workspace-setup': WorkspaceSetup,
    'set-password': SetPassword,
    'profile-setup': UserProfileSetup,
    'verify-otp': VerifyOtp,
    'invite-team': InviteTeamMembers
  }
})
export default class SignUpComponent extends Vue {
  private currentFlow = 'signup';
  private context = {};

  get viewType() {
    switch (this.currentFlow) {
      case 'signup':
        return 'sign-up';
      case 'verify_otp':
        return 'verify-otp';
      case 'set_password':
        return 'set-password';
      case 'profile_setup':
        return 'profile-setup';
      case 'set_workspace':
        return 'workspace-setup';
      case 'invite_team':
        return 'invite-team';
    }
  }

  updateFlow({ flowType, data }) {
    if (!this.$isEmpty(data)) {
      Object.keys(data).forEach(key => {
        this.context[key] = data[key];
      });
    }
    this.currentFlow = flowType;
  }
}
